import { z } from 'zod';

import { jobArchitectureGenerationInfoSchema, jobArchitectureItemSchema } from './job-architecture';
import { jobClusterWithTypeSchemaTransformed } from './job-cluster';

export const jobFamilyWithTypeSchemaTransformed = jobArchitectureItemSchema
    .extend({
        actions: z.object({ canEdit: z.boolean(), canReadDebugInfo: z.boolean() }).optional().default({
            canEdit: false,
            canReadDebugInfo: false,
        }),
        generationInfo: jobArchitectureGenerationInfoSchema.optional(),
    })
    .transform((jobFamily) => ({
        ...jobFamily,
        type: 'job-family' as const,
    }));

export type JobFamily = z.infer<typeof jobFamilyWithTypeSchemaTransformed>;

export const familyWithClustersSchema = jobFamilyWithTypeSchemaTransformed.and(
    z.object({ clusters: jobClusterWithTypeSchemaTransformed.array() }),
);

export type FamilyWithClusters = z.infer<typeof familyWithClustersSchema>;
